import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyPricePipe } from '@delon/util';

interface CreditNotePreviewItem {
  accountCode: string;
  accountName: string;
  description: string;
  amount: number;
}

@Component({
  selector: 'app-transaction-preview-credit-note',
  standalone: true,
  imports: [CurrencyPricePipe, DecimalPipe],
  templateUrl: './transaction-preview-credit-note.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionPreviewCreditNoteComponent {
  @Input() currencyCode: string | null = null;
  @Input() items: CreditNotePreviewItem[] | null = null;
  @Input() totalAmount: number | any = 0;
  @Input() taxableAmount: number | null = null;
  @Input() taxAmount: number | null = null;
  @Input() netTotal: number | null = null;
}
